import { handleActions } from 'redux-actions'
import actions from '../actions'

const initialState = {
  dialogs: [],
  error: false
}

const reducer = handleActions(
  {
    [actions.dialog.add]: (state, { payload }) => ({
      ...state,
      dialogs: [{ ...payload, open: true }]
    }),
    [actions.dialog.remove]: (state, { payload }) => ({
      ...state,
      dialogs: state.dialogs.filter((item) => item.id !== payload)
    }),
    [actions.dialog.update]: (state, { payload }) => ({
      ...state,
      dialogs: state.dialogs.map((item) => (item.id !== payload.id ? item : payload))
    }),
    [actions.dialog.reset]: (state) => ({
      ...state,
      dialogs: []
    }),
    [actions.dialog.error]: (state, { payload }) => ({
      ...state,
      error: payload
    })
  },
  initialState
)

export default reducer
